const ServicesRoutes = {
  getAllServices: "/service/serviceGetAll",
  createService: "/service/serviceCreate",
  updateService: "/service/serviceUpdate",
  deleteService: "/service/serviceDelete"
}

export default ServicesRoutes;